import {TaskModel} from "../../workTableTask/TaskModel";

export enum SurveySessionState {
    pending = "pending",
    executing = "executing",
    completed = "completed",
    cancelled = "cancelled",
    error = "error",
}

export function SurveySessionStateToString(state: SurveySessionState): string {
    switch (state) {
        case SurveySessionState.pending:
            return "Ожидание";
        case SurveySessionState.executing:
            return "Выполняется";
        case SurveySessionState.cancelled:
            return "Отменен";
        case SurveySessionState.completed:
            return "Завершен";
        case SurveySessionState.error:
            return "Ошибка";
    }

}


export interface SurveySessionModel {
    id: string;
    state: SurveySessionState;
    formId: string;
    campaignId: string;
    campaignName: string;
    specialGroupId?: string;
    patientId: string;
    patientName: string;
    telegramId?: Number;
    executingTelegramId?: Number;
    name: string;
    answers: SurveySessionAnswerModel[];
    progress: number;
    total: number;
    completed: boolean;
    currentQuestionId: string;
    currentPath: number[];
    createdAt: Date;
    startedAt?: Date;
    finishedAt?: Date;
}

export interface SurveySessionAnswerQuestionModel {
    id: string;
    questionDisplayText: string;
}

export interface SurveySessionAnswerModel {
    questionId: string;
    value: string;
    created: Date;
}

export interface SurveySessionListOptions {
    search?: string,
    campaignId?: string,
    patientId?: string,
    page: number,
    limit: number,
    sort?: string,
}

export type SurveySessionExportOptions = Readonly<{ selectedIds?: string[] }>;

export type SurveySessionExportResponse = Readonly<{
    task: TaskModel;
}>
